import actions from "./actions";
import dayjs from "dayjs";
// import RestaurantTablesForReservations from "../../components/User/Reservations/RestaurantTablesForReservations";

const initState = {
  reservations: [],
  freeTables: [],
  tablesWithReservations: [],
  openEditReservationModal: {},
  openCreateReservationModal: false,
  userReservationHistory: {},
};

export default function restaurantReservationsReducer(
  state = initState,
  { type, ...action }
) {
  switch (type) {
    case actions.GET_TABLES_AND_RESERVATIONS_PER_REGION_SUCCESS:
      return {
        ...state,
        tablesWithReservations: action.tablesWithReservations,
      };

    case actions.GET_RESERVATIONS_PER_REGION_SUCCESS:
      return {
        ...state,
        reservations: action.reservations,
      };

    case actions.CREATE_RESERVATIONS_GET_TABLES_SUCCESS:
      return {
        ...state,
        freeTables: action.reservationTables,
      };

    case actions.CREATE_RESERVATIONS_SUCCESS:
      // Get today's date in the format "YYYY-MM-DD"
      const selectedDay = action.date.format("YYYY-MM-DD");

      // Check if the reservation date is today
      if (action.reservation.reservationDate === selectedDay) {
        // Extract touchSaleTableIds from the action
        const touchSaleTableIds = action.reservation.touchSaleTables.map(
          (table) => table.touchSaleTableId
        );

        // Filter out the freeTables that have matching touchSaleTableIds
        const updatedFreeTables = state.freeTables.filter(
          (table) => !touchSaleTableIds.includes(table.touchSaleTableId)
        );

        return {
          ...state,
          reservations: [...state.reservations, action.reservation],
          freeTables: updatedFreeTables,
        };
      }
      return state;

    case actions.EDIT_RESERVATIONS_SUCCESS:
      const reservationDate = dayjs(action.reservation.reservationDate);
      const selectedDate = reservationDate.isSame(dayjs(action.date), "day");

      if (selectedDate) {
        // Modify reservation if it's today
        const updatedReservations = state.reservations.map((reservation) =>
          reservation.reservationId === action.reservation.reservationId
            ? { ...reservation, ...action.reservation }
            : reservation
        );

        return {
          ...state,
          reservations: updatedReservations,
        };
      } else {
        // Remove reservation if it's not today
        const filteredReservations = state.reservations.filter(
          (reservation) =>
            reservation.reservationId !== action.reservation.reservationId
        );

        return {
          ...state,
          reservations: filteredReservations,
        };
      }

    case actions.DELETE_RESERVATIONS_SUCCESS:
      return {
        ...state,
        reservations: state.reservations.filter(
          (reservation) =>
            reservation.reservationId !==
            action.deletedReservation.reservationId
        ),
      };

    case actions.OPEN_RESERVATION_EDIT_MODAL:
      return { ...state, openEditReservationModal: action.reservation };

    case actions.CLOSE_RESERVATION_EDIT_MODAL:
      return { ...state, openEditReservationModal: {} };

    case actions.OPEN_RESERVATION_CREATE_MODAL:
      return { ...state, openCreateReservationModal: true };

    case actions.CLOSE_RESERVATION_CREATE_MODAL:
      return { ...state, openCreateReservationModal: false };

    case actions.CREATE_RESERVATIONS_CLIENT_HISTORY_SUCCESS:
      return {
        ...state,
        userReservationHistory: action.clientReservationHistory,
      };

    default:
      return state;
  }
}
